import styled from 'styled-components'

import { timingSlower, zIndexModal } from '@syconium/little-miss-figgy'

export const LoadingOverlay = styled.div<{
  isLoading: boolean
}>`
  background: ${o => o.theme.color.deprecated.stoneLighter};
  bottom: 0;
  left: 0;
  opacity: ${o => (o.isLoading ? 0.8 : 0)};
  pointer-events: ${o => !o.isLoading && 'none'};
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity ${timingSlower} ease;
  z-index: ${zIndexModal};
`
